module.exports = __webpack_public_path__ + "static/monei_pay_2_es-4fa3fa7012b9e05b52125879bd8b29b0.png";